"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var logger_1 = require("./util/logger");
var VFMaterial = (function () {
    function VFMaterial(scene, material, properties) {
        this.scene = scene;
        this.properties = properties;
        this.sceneMaterials = [];
        this.sceneMaterials.push(material);
    }
    Object.defineProperty(VFMaterial.prototype, "name", {
        get: function () {
            return this.properties["name"];
        },
        enumerable: true,
        configurable: true
    });
    VFMaterial.prototype.add = function (material) {
        this.sceneMaterials.push(material);
    };
    VFMaterial.prototype.remove = function (material) {
        this.sceneMaterials = this.sceneMaterials.filter(function (obj) { return obj !== material; });
    };
    VFMaterial.prototype.setColor = function (color) {
        this.applyChange(function (material) {
            if (material instanceof babylonjs_1.PBRMaterial) {
                var pbrMaterial = material;
                pbrMaterial.albedoColor = color;
            }
            else if (material instanceof babylonjs_1.StandardMaterial) {
                var standardMaterial = material;
                standardMaterial.diffuseColor = color;
            }
        });
    };
    VFMaterial.prototype.setTexture = function (texture) {
        this.applyChange(function (material) {
            if (material instanceof babylonjs_1.PBRMaterial) {
                var pbrMaterial = material;
                if (pbrMaterial.emissiveTexture === pbrMaterial.albedoTexture) {
                    pbrMaterial.emissiveTexture = texture;
                }
                pbrMaterial.albedoTexture = texture;
            }
            else if (material instanceof babylonjs_1.StandardMaterial) {
                var standardMaterial = material;
                standardMaterial.diffuseTexture = texture;
            }
        });
    };
    VFMaterial.prototype.applyChange = function (func) {
        var e_1, _a;
        if (!this.sceneMaterials) {
            logger_1.default.error("cannot set texture, no materials assigned");
            return;
        }
        try {
            for (var _b = __values(this.sceneMaterials), _c = _b.next(); !_c.done; _c = _b.next()) {
                var material = _c.value;
                var wasFrozen = material.isFrozen;
                if (wasFrozen) {
                    material.unfreeze();
                }
                func(material);
                if (wasFrozen) {
                    material.freeze();
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return VFMaterial;
}());
exports.default = VFMaterial;
